// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExternalChatsModal_wrapper__1Wx2Y","chats":"ExternalChatsModal_chats__HOxES"};